import { render, staticRenderFns } from "./DashboardLayoutAdmin.vue?vue&type=template&id=16ddf1a0"
import script from "./DashboardLayoutAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardLayoutAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayoutAdmin.vue?vue&type=style&index=0&id=16ddf1a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports